import {Injectable} from '@angular/core';
import {MenuItemModel} from '../../models/menu-item';
import {Router} from '@angular/router';
import {Observable, Subject} from 'rxjs';
import { menuItemDataAdmin, menuItemDataUser } from 'src/app/config/menu';
import { recuperarPrimerProcedimiento } from 'src/app/config/procedimientos_registros';
import { environment } from 'src/environments/environment';



@Injectable({
    providedIn: 'root'
})
export class DashboardService {

    public clientChanges$: Subject<any> = new Subject();
    public changeClientActive: boolean = true;
    public headerTitle: string;
    public lastMenuItemSelected: MenuItemModel;
    public lastSubmenuItemSelected: any;

    public menuItemDataOld:MenuItemModel[] = menuItemDataAdmin;
    public menuItemData: MenuItemModel[] = [];

    public isSidenavOpen: Subject<boolean> = new Subject<boolean>();



    constructor(private router: Router) {
        this.isSidenavOpen.next(true);
    }

    public unSelectLastMenuItem() {
        if (this.lastMenuItemSelected) {
            this.lastMenuItemSelected.isSelected = false;
        }
    }

    public unSelectLastSubmenuItem() {
        if (this.lastSubmenuItemSelected) {
            this.lastSubmenuItemSelected.isSelected = false;
        }
    }

    private selectMenuItem(menuItem: MenuItemModel) {
        //console.log('menuItem', menuItem);

        this.lastMenuItemSelected = menuItem;
        // this.setHeaderTitle(menuItem.description);
        menuItem.isSelected = true;
    }

    private selectSubmenuItem(submenuId: string) {
        let father;

        if (father = this.findFather(submenuId)) {
            if (father.expandable && father.expandable.length > 0) {
                father.expandable.filter(submenu => submenu.id === submenuId)
                    .forEach(submenu => {
                        submenu.isSelected = true;
                        this.lastSubmenuItemSelected = submenu;
                    });
            }
        }
    }

    private isMenuExpandable(menuItem: MenuItemModel): boolean {
        return menuItem.expandable && menuItem.expandable.length > 0;
    }

    private getMenuItem(menuItemId: string): MenuItemModel[] {
        if (this.menuItemData) {
            return this.menuItemData.filter(i => i.id === menuItemId) || [];
        } else {
            return [];
        }
    }

    private getSubmenuItem(submenuItemId) {
        const father = this.findFather(submenuItemId);

        if (father && father.expandable && father.expandable.length > 0) {
            return father.expandable
                .filter(submenu => {
                    submenu.father = father;
                    return submenu.id === submenuItemId;
                })[0];
        } else {
            return null;
        }

    }

    private findFather(id: string) {
        let founded = false;
        let father = null;

        this.menuItemDataOld.forEach(menu => {
            if (!founded && menu.expandable) {
                menu.expandable.forEach(submenu => {
                    if (submenu.id === id) {
                        founded = true;
                        father = menu;
                    }
                });
            }
        });

        return father;
    }


    public setMenuItem(menuItemId: string) {
        const menuItem: MenuItemModel = this.getMenuItem(menuItemId)[0];
      //  console.log("Menuitem",menuItem ,"MenuitemSelected", menuItem.isSelected);
       if (menuItem ) {
        this.unSelectLastMenuItem();
        this.unSelectLastSubmenuItem();

        this.selectMenuItem(menuItem);

        if (this.isMenuExpandable(menuItem)) {
            const submenu = menuItem.expandable[0];
            this.selectSubmenuItem(submenu.id);
            this.setHeaderTitle(submenu.text);

            this.router.navigate(['dashboard', submenu.id]);
        } else {
            this.setHeaderTitle(menuItem.description);

            this.router.navigate(['dashboard', menuItemId]);
        }
    }
        /* if (menuItem && !menuItem.isSelected) {
            this.unSelectLastMenuItem();
            this.unSelectLastSubmenuItem();

            this.selectMenuItem(menuItem);

            if (this.isMenuExpandable(menuItem)) {
                const submenu = menuItem.expandable[0];
                this.selectSubmenuItem(submenu.id);
                this.setHeaderTitle(submenu.text);

                this.router.navigate(['dashboard', submenu.id]);
            } else {
                this.setHeaderTitle(menuItem.description);

                this.router.navigate(['dashboard', menuItemId]);
            }
        } */
    }

    public setSubmenuItem(submenuItemId: string) {
        const submenuItem = this.getSubmenuItem(submenuItemId);


        if (submenuItem) {
            if (!submenuItem.father.isSelected) {
                this.unSelectLastSubmenuItem();
                this.unSelectLastMenuItem();
                this.selectMenuItem(submenuItem.father);
            }

            this.unSelectLastSubmenuItem();
            this.selectSubmenuItem(submenuItem.id);

            this.setHeaderTitle(submenuItem.text);
            this.router.navigate(['dashboard', submenuItemId]);
        }
    }

    public setHeaderTitle(headerTitle: string) {
        this.headerTitle = headerTitle;
    }

    public onMenuItemClick(menuItemId: string) {
        this.setMenuItem(menuItemId);
        menuItemId = recuperarPrimerProcedimiento(menuItemId);
        localStorage.setItem('id_documento_registro',menuItemId);
    }

    public onSubmenuItemClick(submenuItemId: string) {
        this.setSubmenuItem(submenuItemId);
    }

    public onChangeClient(): Observable<any> {
        return this.clientChanges$.asObservable();
    }

    public emitClientChange() {
        this.clientChanges$.next();
    }

/**
 *
 *  Construimos nuestro menu, con la informacion,
 *  recogida de la base de datos y que esta guardadad
 *  en localstorage @revisarMenu
 *
 */
    // public revisarMenu(){

    //     this.menuItemData = [];
    //     if(localStorage.getItem('role') != null && localStorage.getItem('role') == "ROLE_ADMIN" ) {
    //         let datos = JSON.parse(localStorage.getItem('calidad_user_tag_1'));

    //       try {


    //         let nombre: string =  datos.name;
    //         if( nombre.localeCompare('Locatec') == 0) {
    //             this.menuItemDataOld = menuItemDataAdmin;
    //         }
    //       } catch (error) {

    //       }
    //         this.menuItemData = this.menuItemDataOld;
    //     }else{
    //         this.menuItemData = this.menuItemDataOld;

    //         if (localStorage.getItem('documentos') != null ) {
    //             let arrayDocumentos = localStorage.getItem('documentos').split(";");

    //             let idx;

    //             for (let index = 0; index < (arrayDocumentos.length); index++) {
    //                 const element = arrayDocumentos[index].replace("\"","");
    //                // console.log("element",element);
    //                 //console.log("element ",element);
    //                 for (let index2 = 0; index2 < this.menuItemDataOld.length; index2++) {
    //                     const elemento = this.menuItemDataOld[index2].id;
    //                     //console.log('elemento', elemento , 'element', element);
    //                     if (elemento.localeCompare(element) == 0 ) {

    //                         this.menuItemData.push(this.menuItemDataOld[index2]);
    //                     }

    //                 }

    //             }

    //         }
    //     }
    // }

    public revisarMenu() {
        this.menuItemData = [];

        // console.log(menuItemDataAdmin)
        // console.log(this.menuItemDataOld)

        if (environment.appName ==='campanaragricola') {
            this.menuItemDataOld = menuItemDataAdmin;
            this.menuItemData = this.menuItemDataOld;
            return;
        }


        if (localStorage.getItem('role') != null && localStorage.getItem('role') == "ROLE_ADMIN") {
            let datos = JSON.parse(localStorage.getItem('calidad_user_tag_1'));

            try {
                let nombre: string = datos.name;
                if (nombre.localeCompare('Locatec') == 0) {
                    this.menuItemDataOld = menuItemDataAdmin;
                    this.menuItemData = this.menuItemDataOld;
                }else{
                    let documentosStr = localStorage.getItem('documentos').replace(/"/g, '') || '';

                    // In case user is ROLE_ADMIN and doesnt have any 'documentos' it will show all
                    if (documentosStr === ''){
                        this.menuItemData = this.menuItemDataOld;
                    }else{

                        let arrayDocumentos = documentosStr.split(";").map(doc => doc.trim()).filter(doc => doc);
                        // this.menuItemData = this.menuItemDataOld;
                        let clientesMenuItem = this.menuItemDataOld.find(menuItem => menuItem.id === 'clientes');

                        if (clientesMenuItem) {
                            this.menuItemData.push(clientesMenuItem);
                        }
                        for (let menuItem of this.menuItemDataOld) {

                            if (menuItem.id === 'clientes') {
                                continue;
                            }

                            let newMenuItem = { ...menuItem };

                            newMenuItem.isSelected = true;

                            if (arrayDocumentos.includes(menuItem.id)) {
                                this.menuItemData.push(newMenuItem);
                            } else if (menuItem.expandable && menuItem.expandable.length > 0) {

                                let matchingExpandables = menuItem.expandable.filter(submenu => {
                                    return arrayDocumentos.includes(submenu.id) ;
                                });

                                if (matchingExpandables.length > 0) {
                                    newMenuItem.expandable = matchingExpandables;
                                    this.menuItemData.push(newMenuItem);
                                }
                            }
                        }
                    }
                }
            } catch (error) {
                console.error(error);
            }
        } else {
            let documentosStr = localStorage.getItem('documentos').replace(/"/g, '') || '';
            let arrayDocumentos = documentosStr.split(";").map(doc => doc.trim()).filter(doc => doc);

            let clientesMenuItem = this.menuItemDataOld.find(menuItem => menuItem.id === 'clientes');

            if (clientesMenuItem) {
                this.menuItemData.push(clientesMenuItem);
            }


            for (let menuItem of this.menuItemDataOld) {

                if (menuItem.id === 'clientes') {
                    continue;
                }

                let newMenuItem = { ...menuItem };

                newMenuItem.isSelected = true;

                if (arrayDocumentos.includes(menuItem.id)) {
                    this.menuItemData.push(newMenuItem);
                } else if (menuItem.expandable && menuItem.expandable.length > 0) {

                    let matchingExpandables = menuItem.expandable.filter(submenu => {
                        return arrayDocumentos.includes(submenu.id) ;
                    });

                    if (matchingExpandables.length > 0) {
                        newMenuItem.expandable = matchingExpandables;
                        this.menuItemData.push(newMenuItem);
                    }
                }
            }
        }
    }



    public deleteMenu(){
        this.menuItemData = [];
    }
}
